// src/pages/LoginPage.tsx
import React from 'react';
import GoogleLoginButton from '../components/GoogleLoginButton';

interface LoginPageProps {
    onSuccess: (credentialResponse: any) => void;
    onFailure: (error: any) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onSuccess, onFailure }) => {
    const primary = '#8d3939ff';

    return (
        <main style={pageStyle} aria-labelledby="login-title">
            <section style={containerStyle}>
                <div style={cardStyle} role="region" aria-label="Login card">
                    <div style={leftStyle}>
                        <div style={{ ...logoStyle, background: primary }}>λ</div>
                    </div>

                    <div style={rightStyle}>
                        <h1 id="login-title" style={{ ...headingStyle, color: primary }}>Lambda Studio IDE <span style={{ fontWeight: 400, fontSize: 14 }}> V0.1 - beta</span></h1>
                        <p style={subTextStyle}>Sign in to access your projects and run parametric simulations.</p>

                        <div style={{ marginTop: 18 }}>
                            <GoogleLoginButton onSuccess={onSuccess} onFailure={onFailure} />
                        </div>

                        <p style={helpStyle}>
                            Lambda Studio IDE is an advanced tool for simulating complex optical systems.<br></br> PhD. Emiliano Jan - 2026
                        </p>
                        <p style={disclaimerStyle}>
                            This software is an MVP (Minimum Viable Product). It may contain simulation errors and produce unintended results. Use with caution.
                        </p>
                    </div>
                </div>
            </section>
        </main>
    );
};

// Layout styles
const pageStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 40px)',
    width: '100%',
    background: 'linear-gradient(180deg, #fff 0%, #fbfbfb 100%)',
    padding: 20,
};

const containerStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: 900,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const cardStyle: React.CSSProperties = {
    display: 'flex',
    gap: 20,
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 12px 30px rgba(0,0,0,0.12)',
    overflow: 'hidden',
    width: '100%',
    alignItems: 'center',
    padding: 22,
};

const leftStyle: React.CSSProperties = {
    flex: '0 0 140px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const logoStyle: React.CSSProperties = {
    width: 120,
    height: 120,
    borderRadius: 12,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 200,
    fontSize: 82,
};

const rightStyle: React.CSSProperties = {
    flex: 1,
    minWidth: 0,
};

const headingStyle: React.CSSProperties = {
    margin: 0,
    fontSize: 22,
    fontWeight: 600,
};

const subTextStyle: React.CSSProperties = {
    margin: '8px 0 16px',
    color: '#444',
    lineHeight: 1.4,
};

const helpStyle: React.CSSProperties = {
    marginTop: 14,
    fontSize: 13,
    color: '#666',
};

const disclaimerStyle: React.CSSProperties = {
    marginTop: 12,
    fontSize: 12,
    color: '#8a8a8a',
    lineHeight: 1.2,
    fontStyle: 'italic',
};

const linkStyle: React.CSSProperties = {
    color: '#8d3939ff',
    textDecoration: 'none',
    fontWeight: 600,
};

export default LoginPage;

